// ExternalPage.jsx
import { useEffect, useRef, useState } from "react";

export default function ExternalPage({ src, title = "External page" }) {
  const [error, setError] = useState(false);
  const frameRef = useRef(null);

  // (선택) 같은 출처일 때 postMessage로 높이 자동조절을 받도록 리스너 등록
  useEffect(() => {
    const onMsg = (e) => {
      if (e?.data?.type === "resize-iframe" && frameRef.current) {
        frameRef.current.style.height = `${e.data.height}px`;
      }
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);

  return (
    <div style={{
      width: "100%",
      height: "80vh",
      border: "1px solid #e5e7eb",
      borderRadius: 8,
      overflow: "hidden"
    }}>
      {!error ? (
        <iframe
          ref={frameRef}
          src={src}
          title={title}
          style={{ width: "100%", height: "100%", border: "none" }}
          loading="lazy"
          // 필요 권한만 남기세요. same-origin이 아니면 내부 DOM 접근 불가.
          sandbox="allow-scripts allow-forms allow-same-origin allow-popups"
          allow="fullscreen; geolocation; microphone; camera"
          onError={() => setError(true)}
        />
      ) : (
        <div style={{ padding: 16, fontSize: 14 }}>
          이 페이지는 임베드가 차단되어 있어요.{" "}
          <a href={src} target="_blank" rel="noreferrer" style={{ color: "#2563eb", textDecoration: "underline" }}>
            새 탭에서 열기
          </a>
        </div>
      )}
    </div>
  );
}
